import { SpinResponse } from '@cgs/data-access';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  GameStateMachine,
  IGameStateMachineProvider,
  RESOURCES_COMPONENT_TOKEN,
  ResourcesComponent,
} from '@cgs/machines';
import {
  Compatibility,
  Container,
  debounce,
  RESIZE_HANDLER_TOKEN,
  ResizeHandler,
  Vector2,
  viewportChangeListener,
} from '@cgs/wge';

export const SANTA_BACKGROUND_IMAGE_RESIZE_COMPONENT_TOKEN = Symbol(
  'SANTA_BACKGROUND_IMAGE_RESIZE_COMPONENT_TOKEN'
);

export class SantaBackgroundImageResizeComponent {
  private readonly resizeHandler: ResizeHandler;
  private readonly resourceComponent: ResourcesComponent;
  private readonly gameStateMachine: GameStateMachine<SpinResponse>;

  constructor(container: Container) {
    this.resizeHandler = container.resolve<ResizeHandler>(RESIZE_HANDLER_TOKEN);
    this.resourceComponent = container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);

    this.gameStateMachine = container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;

    this.init();
  }

  private init(): void {
    const debouncedResize = debounce(() => this.resize(), 100);

    viewportChangeListener.on(debouncedResize);

    this.gameStateMachine.init.entered.listen(() => this.resize());
    this.gameStateMachine.beginFreeSpinsPopup.leaved.listen(() => this.resize());
    this.gameStateMachine.endFreeSpinsPopup.leaved.listen(() => this.resize());

    this.resize();
  }

  private resize(): void {
    if (!Compatibility.IsMobileBrowser) {
      if (window.innerWidth < window.innerHeight) {
        this.resizeVertical();
        return;
      }
      this.resizeHorizontal();
      return;
    }
  }

  private resizeVertical(): void {}

  private resizeHorizontal(): void {
    const ratio = window.innerHeight / window.innerWidth;

    const imageWidth = this.resourceComponent.bg.size.x;
    const imageHeight = this.resourceComponent.bg.size.y;

    const imageRatio = imageWidth / imageHeight;

    let backgroundScale = 1;
    backgroundScale = 1 / (imageRatio * ratio);

    if (ratio > 0.47) {
      backgroundScale = 1;
    }
    this.resourceComponent.bg.scale = new Vector2(backgroundScale, backgroundScale);
  }
}
